module.exports = __webpack_public_path__ + "static/img/click.80c324bc.gif";